"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CalendarDayGrid = void 0;
var CalendarDayGrid_base_1 = require("./CalendarDayGrid.base");
var CalendarDayGrid_styles_1 = require("./CalendarDayGrid.styles");
var Utilities_1 = require("../../Utilities");
exports.CalendarDayGrid = (0, Utilities_1.styled)(CalendarDayGrid_base_1.CalendarDayGridBase, CalendarDayGrid_styles_1.styles, undefined, { scope: 'CalendarDayGrid' });
//# sourceMappingURL=CalendarDayGrid.js.map